<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  @switch (importStep()) {
    <!-- Step 1: File Upload -->
    @case (1) {
      <form [formGroup]="fileUploadForm" (ngSubmit)="onFileSelected()">
        <file-upload formControlName="files" name="files"></file-upload>
        <button
          mat-raised-button
          color="primary"
          type="submit"
          [disabled]="!fileUploadForm.valid"
        >
          Upload and Analyze
        </button>
      </form>
    }
    <!-- Step 2: Version Selection (if multiple versions available) -->
    @case (2) {
      <h3>Select Version to Import</h3>
      <mat-radio-group [ngModel]="selectedVersionId()" (ngModelChange)="selectedVersionId.set($event)">
        @for (version of versions(); track version.versionId) {
          <mat-radio-button [value]="version.versionId">
            Version {{ version.majorVersion }}.{{ version.minorVersion }}
          </mat-radio-button>
        }
      </mat-radio-group>
      <button
        mat-raised-button
        color="primary"
        (click)="onVersionSelected(selectedVersionId())"
      >
        Continue
      </button>
    }
    <!-- Step 4: Project Name Confirmation -->
    @case (4) {
      <form [formGroup]="projectNameForm" (ngSubmit)="onProjectNameSubmitted()">
        <mat-form-field>
          <mat-label>Project Name</mat-label>
          <input matInput formControlName="projectName" />
          @if (projectNameForm.get("projectName")?.hasError("notUnique")) {
            <mat-error>
              A project with this name already exists. Please choose a different
              name.
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field [formGroup]="passwordForm">
          <mat-label>Password</mat-label>
          <input matInput formControlName="password" type="password" />
          @if (passwordForm.get("password")?.hasError("minlength")) {
            <mat-error>
              Password must be at least 8 characters long.
            </mat-error>
          }
        </mat-form-field>
        <button mat-raised-button color="primary" type="submit">
          Import Project
        </button>
      </form>
    }
    <!-- Step 5: Import Progress -->
    @case (5) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      <p>Importing project, please wait...</p>
    }
    <!-- Step 6: Import Results -->
    @case (6) {
      <h3>Import Completed</h3>
      @if (warnings().length > 0) {
        <h4>Warnings:</h4>
        <ul>
          @for (warning of warnings(); track $index) {
            <li>{{ warning }}</li>
          }
        </ul>
        <button mat-raised-button color="primary" (click)="copyWarnings()">
          Copy Warnings
        </button>
      }
      @if (warnings().length === 0) {
        <p>Import completed successfully!</p>
      }
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (importStep() !== 5) {
    <button mat-button (click)="closeDialog()">Cancel</button>
  }
  @if (importStep() === 6) {
    <button mat-raised-button color="primary" (click)="closeDialog()">
      Close
    </button>
  }
</mat-dialog-actions>
